var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeOverflow,
          expression: "closeOverflow",
        },
      ],
      staticClass: "main-navigation",
    },
    [
      _vm._l(_vm.navigation, function (item) {
        return _c(
          "router-link",
          {
            key: item.route,
            staticClass: "main-navigation-item",
            attrs: { to: item.route },
            nativeOn: {
              click: function ($event) {
                return _vm.closeOverflow.apply(null, arguments)
              },
            },
          },
          [_vm._v(" " + _vm._s(item.text) + " ")]
        )
      }),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.overflowExists,
              expression: "overflowExists",
            },
          ],
          ref: "showMore",
          staticClass: "show-more",
          on: { click: _vm.toggleOverflow },
        },
        [
          _vm._v(" Mehr "),
          !_vm.overflowShown
            ? _c("font-awesome-icon", { attrs: { icon: "caret-down" } })
            : _vm._e(),
          _vm.overflowShown
            ? _c("font-awesome-icon", { attrs: { icon: "caret-up" } })
            : _vm._e(),
        ],
        1
      ),
      _c("nav", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.overflowShown,
            expression: "overflowShown",
          },
        ],
        ref: "overflowNavigation",
        staticClass: "overflow-navigation",
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }